import { render, staticRenderFns } from "./userSet.vue?vue&type=template&id=585617ca&scoped=true&"
import script from "./userSet.vue?vue&type=script&lang=js&"
export * from "./userSet.vue?vue&type=script&lang=js&"
import style0 from "./userSet.vue?vue&type=style&index=0&id=585617ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585617ca",
  null
  
)

export default component.exports